export type GISService = {
  id: number;
  gisLayerID: string;
  auto_checked?: boolean;
  service_type: number;
  display_order: number;
  gis_service_url: string;
  token?: string;
  layerIndex: number;
  display_name: string;
  attributes: {
    is_click_to_identify_service?: boolean;
    gis_service_category?: string;
    sublayers?: string[];
    layer_settings: { layer_id: string };
  };
};

export enum GISServiceTypes {
  basemap = 0,
  supplemental = 1,
  geocode = 2,
  wms = 3,
  wmts = 4,
}

export type GISIdentity = {
  arcgis_token: string;
  geocomm_url: string;
  gis_identity_url: string;
  token_expires_in: number;
  gis_services: GISService[];
};

export type MappedGISIdentity = {
  arcGISToken: string;
  gisServices: GISService[];
  gisIdentityUrl: string;
  tokenExpiresIn: number;
};

/**
 * These are additional properties we want to track about a layer/sublayer for
 * our own purposes. (Future hint: opacity, etc)
 */
type GISLayerProperties = {
  title: string;
  active: boolean;
};

export type GISStateSublayer = GISLayerProperties & {
  /** The id used by GIS */
  id: number | string;
  /** The id used by sublayerFor */
  uniqueId: string;
  service: GISService;
};

export type GISStateLayer = GISLayerProperties & {
  id: string;
  service: GISService;
  sublayers: GISStateSublayer[];
};

export type GISServicesState = {
  error?: { message: string; status?: number };
  gisIdentities: MappedGISIdentity[];
  services: GISService[];
  layers: GISStateLayer[];
  loading: boolean;
};
